/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class ProfileAddress {
    id?: number; // ecf001
    streetName?: string; // ecf001
    streetExtra?: string; // ecf001
    houseNumber?: number; // ecf001
    postalCode?: string; // ecf001
    //postalIndex?: string; // ecf001 => Not using this anymore since we are using BestAddresses now
    cityName?: string; // ecf001
    countryIsoCode?: string; // ecf001
    bestAddressStreetId: string; // ecf001
    bestAddressId: string; // ecf001

    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): ProfileAddress {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; }
        if (data.streetName != null) {instance.streetName = data.streetName; }
        if (data.streetExtra != null) {instance.streetExtra = data.streetExtra; }
        if (data.houseNumber != null) {instance.houseNumber = data.houseNumber; }
        if (data.postalCode != null) {instance.postalCode = data.postalCode; }
        //if (data.postIndex != null) {instance.postIndex = data.postIndex; }
        if (data.cityName != null) {instance.cityName = data.cityName; }
        if (data.countryIsoCode != null) {instance.countryIsoCode = data.countryIsoCode; }
        if (data.bestAddressStreetId != null) {instance.bestAddressStreetId = data.bestAddressStreetId; }
        if (data.bestAddressId != null) {instance.bestAddressId = data.bestAddressId; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return ProfileAddress.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: ProfileAddress) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return ProfileAddress.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: ProfileAddress): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
